import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

import { COLORS } from 'theme';

const TripUnavailableIcon = (props) => (
  <SvgIcon viewBox="0 0 76 76" {...props}>
    <circle cx="38" cy="38" r="37" fill={props.sx?.color || COLORS.red} />
    <path
      d="M26 17.999c-2.21 0-4 1.79-4 4v32c0 2.21 1.79 4 4 4h20.19l-.07-.121-5.257-3.117a5.793 5.793 0 0 1-2.836-5.582 5.796 5.796 0 0 1 3.836-4.95l12.136-4.37v-17.86c0-2.21-1.79-4-4-4H26Zm34.171 24c-.206 0-.416.037-.629.113l-16.324 5.88c-1.468.53-1.658 2.53-.316 3.327l6.137 3.641 3.64 6.137c.362.61.976.902 1.586.902.728 0 1.454-.419 1.742-1.219l5.88-16.324C62.333 43.21 61.37 42 60.17 42Zm-3.609 5.438-2.773 7.69-1.309-2.206-.52-.879-.879-.52-2.207-1.312 7.688-2.773Z"
      fill={props.sx?.colorSecondary || COLORS.redLight}
    />
  </SvgIcon>
);

TripUnavailableIcon.propTypes = {
  sx: PropTypes.object,
};

export default TripUnavailableIcon;
